export enum FulfillmentTypeId {
  Unknown = 0,
  DealerMarketplace = 1,
  PartnerRetail = 2,
  Core = 3,
  Oem = 4
}

export enum FulfillmentTypeKey {
  Unknown = 'Unknown',
  DealerMarketplace = 'DealerMarketplace',
  PartnerRetail = 'PartnerRetail',
  Core = 'Core',
  Oem = 'Oem'
}

export const FulfillmentKeyMap: Record<FulfillmentTypeKey, FulfillmentTypeId> =
  {
    [FulfillmentTypeKey.Unknown]: FulfillmentTypeId.Unknown,
    [FulfillmentTypeKey.DealerMarketplace]: FulfillmentTypeId.DealerMarketplace,
    [FulfillmentTypeKey.PartnerRetail]: FulfillmentTypeId.PartnerRetail,
    [FulfillmentTypeKey.Core]: FulfillmentTypeId.Core,
    [FulfillmentTypeKey.Oem]: FulfillmentTypeId.Oem
  } as const;

export const FulfillmentIdMap: Record<FulfillmentTypeId, FulfillmentTypeKey> = {
  [FulfillmentTypeId.Unknown]: FulfillmentTypeKey.Unknown,
  [FulfillmentTypeId.DealerMarketplace]: FulfillmentTypeKey.DealerMarketplace,
  [FulfillmentTypeId.PartnerRetail]: FulfillmentTypeKey.PartnerRetail,
  [FulfillmentTypeId.Core]: FulfillmentTypeKey.Core,
  [FulfillmentTypeId.Oem]: FulfillmentTypeKey.Oem
} as const;
